import { useCallback, useState } from 'react'

export function ReferenceFrame({ src, title }: { src: string; title: string }) {
  const [height, setHeight] = useState(900)
  const onLoad = useCallback((event: React.SyntheticEvent<HTMLIFrameElement>) => {
    const frame = event.currentTarget
    const doc = frame.contentDocument
    if (!doc) return
    const style = doc.createElement('style')
    style.textContent = '.top,.guide,footer.site,.to-top,.global-financial-disclaimer{display:none!important}body .wrap{max-width:none!important;padding:8px 10px 20px!important}'
    doc.head.appendChild(style)
    const resize = () => setHeight(Math.max(600, Math.min(20_000, doc.documentElement.scrollHeight + 8)))
    new MutationObserver(resize).observe(doc.body, { subtree: true, childList: true, attributes: true })
    resize()
  }, [])
  return <iframe className="module-frame reference-frame" src={src} title={title} onLoad={onLoad} style={{ height }} />
}
